/**
 * 숫자에 1000단위 콤마를 추가한 문자열 반환
 * @param value - 변환할 숫자
 */
export const numberWithCommas = (value: number): string => {
  if (typeof value !== 'number' || isNaN(value)) {
    throw new Error('숫자 필요');
  }

  const [integer, decimal] = value.toString().split('.');
  const formatted = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return decimal ? `${formatted}.${decimal}` : formatted;
};
